export default function setWindowObject({
    userName, // user name
    email, // user email
    accountId, // user account id
    article_record_type, // category name
    step_number, // only for troubleshooting article steps
    article_title, // article title for trouble shooting, sub section level 1 title for faq
}) {
    
    window.foxtel = {
        user: {
            name: userName,
            email,
            accountId,
        },
        hc: {
            article_record_type,
            step_number,
            article_title,
        },
    };
}
